<template>
  <div>
    <pregnant-AminoAcid :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' :predictionTypeCode="predictionTypeCode" :energySystemNameA='energySystemNameA' v-if="predictionTypeCode=='gestatingSows'" />
    <aminoAcid :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' :predictionTypeCode="predictionTypeCode" :energySystemNameA='energySystemNameA' v-else/>
  </div>
</template>
<script>
import AminoAcid from './AminoAcid/AminoAcid.vue'
import PregnantAminoAcid from "./AminoAcid/PregnantAminoAcid.vue"
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from 'vuex'
export default {
  components: { AminoAcid,PregnantAminoAcid},
  props:['isAdd','resId','tabKey','details','predictionTypeCode'],
  data() {
    return {
      property: "value",
      mode: 0,
      list: [],
      estimateId: getRequest("id"),
    };
  },

  computed: {
    ...mapState('estimate',['dataDictionary']),
    energySystemNameA(){
      let name = ''
      let {EnergySystem} = this.dataDictionary || {}
      let {prediction} = this.details || {}
      let {energySystem} = prediction || {}
      if(EnergySystem && EnergySystem.length){
        let obj = EnergySystem.find(el => el.dictKey === energySystem) || {}
        name = obj.dictValue
      }
      return name
    },
  },
};
</script>